var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-footer" },
    [
      _c("TableSettings", {
        attrs: { config: _vm.config },
        on: {
          "update-column": function(params) {
            return _vm.$emit("update-column", params)
          },
          "reset-settings": function($event) {
            return _vm.$emit("reset-settings")
          }
        }
      }),
      _vm._v(" "),
      _c("TablePagination", {
        attrs: { "current-page": _vm.currentPage, pages: _vm.pages },
        on: {
          "change-page": function(val) {
            return _vm.$emit("change-page", val)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }